export default __webpack_public_path__ + "static/media/mike.6751efac.png";